//  This cell renderer is for keyword review modal during bulk keyword addition
import { useEffect, useState } from "react";
import { ICellRendererParams } from "ag-grid-community";

interface IUpdateWithInputCellRenderer extends ICellRendererParams {
    origin: string;
    // Unable to access its type as its private type in ag-grid
    column: any;
}

const UpdateBidInputCellRenderer: React.FC<IUpdateWithInputCellRenderer> = (
    params
) => {
    const [identifier, setIdentifier] = useState<string>("");
    const [inputvalue, setInputValue] = useState<number>(0)

    useEffect(() => {
        if (params.data) {
            setIdentifier(
                `${params.data.keywordId}_${params.data.matchType}`
            );
            setInputValue(+params.data[params.column.colId])
        }
    }, [params.origin, params.data, params.node.rowIndex, params.column.colId]);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setInputValue(+e.target.value)
    }

    return (
        <>
            {params.node.rowPinned ? null : (
                <>
                    <div
                        className="ag-cell-wrapper updateInput in"
                        id={`${params.column.colId}-${identifier}-btn`}
                    ></div>

                    <div
                        className=""
                        style={{
                            display: "block",
                        }}
                    >
                        <>
                            <input
                                type="number"
                                id={`${params.column.colId}-${identifier}-update-field`}
                                data-id={identifier}
                                className="form-control border border-primary"
                                value={inputvalue}
                                onChange={handleChange}
                            />
                        </>

                    </div>
                </>
            )}
        </>
    );
};

export default UpdateBidInputCellRenderer;


